import React from 'react';
import useSheet from 'app/jss';

type Props = {
  classes: object,
  children: any,
  onRef?: any,
};

const defaultProps = {
  onRef: undefined,
};

function GroupContainerCategories({
    classes,
    children,
    onRef,
  }: Props) {
  return (
    <div ref={onRef} className={classes.friendCategories}>
      {children}
    </div>
  );
}

GroupContainerCategories.defaultProps = defaultProps;

function applyStyles(theme: Theme) {
  return {
    friendCategories: {
      display: 'flex',
      flexShrink: 0,
      alignItems: 'center',
    },
  };
}

export default useSheet(applyStyles)(GroupContainerCategories);
